import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Button, Col, Row } from "reactstrap";
import { RSelect } from "../../components/Component";
import { GET, POST } from "../../helper/api";


export const TimeKeepingHoliday = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [holidayOptions, setHolidayOptions] = useState([])
  const [userOptions, setUserOptions] = useState([]);
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      userIds: [],
      holidayIds: [],
    },
  });
  useEffect(() => {
    GET("/user/list-workers", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
    GET(`holiday`, {
      startDate: moment().startOf('years').format('YYYY-MM-DD'),
      endDate: moment().endOf('years').format('YYYY-MM-DD'),
    }, true)
      .then(({ data }) => {
        setHolidayOptions(data.rows.map(e => ({
          label: `${e.name}: ${e.startDate} - ${e.endDate}`,
          value: e.id,
          data: e
        })));
      })
  }, [])

  const onHandleSubmit = () => {
    setLoading(true);
    const { userIds, holidayIds } = getValues();
    POST(
      `/employee/keepingtime/add-time-keeping-holiday`,
      { userIds, holidayIds },
      {},
      true
    )
      .then(() => {
        toast.success('Chấm công thành công');
        onSuccess?.()
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }
  return <div className="nk-modal">
    <div className="p-2">
      <h5 className="title">Thêm chấm công ngày lễ</h5>
      <div className="mt-4">
        <form onSubmit={handleSubmit(onHandleSubmit)}>
          <Row className="g-3">

            <Col md="12">
              <div className="form-group">
                <label className="form-label" htmlFor="customer">
                  Nhân viên
                  <span className="text-danger">*</span>
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="userIds"
                    rules={{
                      validate: (v) => v?.length > 0 || "Vui lòng nhập thông tin"
                    }}
                    render={({ onChange, value, name, ref }) => (
                      <RSelect
                        isMulti
                        classNamePrefix="form-control"
                        inputRef={ref}
                        name={name}
                        options={userOptions}
                        value={userOptions.filter(
                          (c) => value?.includes(c.value)
                        )}
                        onChange={(val) => {
                          onChange(val.map(e => e.value))
                        }}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="userIds"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>


            <Col md="12">
              <div className="form-group">
                <label className="form-label" htmlFor="customer">
                  Ngày lễ
                  <span className="text-danger">*</span>
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="holidayIds"
                    rules={{
                      validate: (v) => v?.length > 0 || "Vui lòng nhập thông tin"
                    }}
                    render={({ onChange, value, name, ref }) => (
                      <RSelect
                        isMulti
                        classNamePrefix="form-control"
                        inputRef={ref}
                        name={name}
                        options={holidayOptions}
                        value={holidayOptions.filter(
                          (c) => value?.includes(c.value)
                        )}
                        onChange={(val) => {
                          onChange(val.map(e => e.value))
                        }}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="holidayIds"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>

            <Col size="12">
              <Button color="primary" type="submit" disabled={loading}>
                <span>Thêm</span>
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    </div>
  </div>

}